<div class="container-full bg-gradient">
    <form id="registerForm" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <mat-card>
            <img src="assets/logo-inline.png" class="logo"/>

            <h1 class="free-trial">
                Essayez gratuitement
            </h1>

            <mat-card-content>
                <app-alert></app-alert>
                <div class="btns_social">
                    <a class="btn btn-facebook" (click)="signInWithFB()">
                        <img src="/assets/logo-facebook.avif"/>
                    </a>
                    <a class="btn btn-google" (click)="signInWithGoogle()">
                        <img src="/assets/Google_icon-icons.com_66793.png"/>
                    </a>
                </div>
                <hr class="ou">
                <div class="row">
                    <div class="col-6">
                        <div class="form-group">
                            <mat-form-field>
                                <mat-label>Prénom</mat-label>
                                <input matInput formControlName="firstName" placeholder="Prénom" class="text">
                                <mat-error
                                    *ngIf="registerForm.get('firstName').invalid"f>{{ formService.getErrorMessage(registerForm.get('firstName')) }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <mat-form-field>
                                <mat-label>Nom</mat-label>
                                <input matInput formControlName="lastName" placeholder="Nom" class="text">
                                <mat-error
                                    *ngIf="registerForm.get('lastName').invalid">{{ formService.getErrorMessage(registerForm.get('lastName')) }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <mat-form-field>
                        <mat-label>E-mail</mat-label>
                        <input matInput formControlName="username" placeholder="E-mail" class="text">
                        <mat-error
                            *ngIf="registerForm.get('username').invalid">{{ formService.getErrorMessage(registerForm.get('username')) }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-group">
                    <mat-form-field>
                        <mat-label>Mot de passe</mat-label>
                        <input matInput formControlName="text_password" [type]="hide ? 'password' : 'text'"
                               class="text">
                        <p mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                           [attr.aria-pressed]="hide">
                            <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </p>
                        <!--                            <mat-hint><a href="#">Mot de passe oublié</a></mat-hint>-->
                        <mat-error
                            *ngIf="registerForm.get('text_password').invalid">{{ formService.getErrorMessage(registerForm.get('text_password')) }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-group" [hidden]="affiliateInfo != null">
                    <a (click)="showParrainage()" class="add_parrainage">Ajoutez un code parrainage <i
                        class="fa fa-caret-down"></i></a>
                    <mat-form-field style="display: none;" class="parrainage_field">
                        <mat-label>Code de parrainage</mat-label>
                        <input matInput formControlName="parainage" type="text" class="text">
                        <mat-error
                            *ngIf="registerForm.get('parainage').invalid">{{ formService.getErrorMessage(registerForm.get('parainage')) }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Remise -X% (discount < 100) -->
                <div *ngIf="affiliateInfo && affiliateInfo.discount > 0 && affiliateInfo.discount < 100 && !affiliateInfo.anonym"
                     class="affiliate_message d-flex align-items-center">
                    <img src="{{ affiliateInfo.picture }}" style="{{ affiliateInfo.picture_style }}"/>
                    <p class="mb-0">
                        Grâce à {{ affiliateInfo.name }}, vous bénéficiez de <b>-{{ affiliateInfo.discount }}% de
                        remise {{ affiliateInfo.condition }} sur tous les abonnements LyBox !</b>
                    </p>
                </div>

                <div *ngIf="affiliateInfo && affiliateInfo.discount > 0 && affiliateInfo.discount < 100 && affiliateInfo.anonym"
                     class="affiliate_message">
                    <p class="mb-0">
                        Grâce à notre partenaire, vous bénéficiez de <b>-{{ affiliateInfo.discount }}% de
                        remise {{ affiliateInfo.condition }} sur tous les abonnements LyBox !</b>
                    </p>
                </div>

                <!-- 1 mois offert (discount >= 100) -->
                <div *ngIf="affiliateInfo && affiliateInfo.discount >= 100 && !affiliateInfo.anonym"
                     class="affiliate_message d-flex align-items-center">
                    <img src="{{ affiliateInfo.picture }}" style="{{ affiliateInfo.picture_style }}"/>
                    <p class="mb-0">
                        Grâce à {{ affiliateInfo.name }}, vous bénéficiez <b>d'un mois offert sur tous les abonnements
                        LyBox !</b>
                    </p>
                </div>

                <div *ngIf="affiliateInfo && affiliateInfo.discount >= 100 && affiliateInfo.anonym"
                     class="affiliate_message">
                    <p class="mb-0">
                        Grâce à notre partenaire, vous bénéficiez <b>d'un mois offert sur tous les abonnements LyBox !</b>
                    </p>
                </div>

            </mat-card-content>
            <mat-card-actions>
                <button class="btn btn-primary w-100">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Créer mon compte
                </button>
                <p class="mt-2">
                    Vous êtes déjà inscrit ?
                    <a [routerLink]="['/app/login']" [queryParams]="{returnUrl: returnUrl}">Connectez-vous</a>
                </p>
                <div class="text-center">
                    <small>En m'inscrivant, je déclare avoir pris connaissance des <a
                        href="https://www.lybox.fr/cgu" target="_blank">conditions générales d’utilisation</a>
                        du site internet et les accepter.</small>
                </div>
            </mat-card-actions>
        </mat-card>

    </form>
</div>
